import { all, takeEvery, call, put } from 'redux-saga/effects';
import actions from './actions';
import propertyActions from '../properties2/actions';
import appActions from '../app/actions';
import SuperFetch from '../../helpers/superFetch';
import { apiUrls } from '../../settings';
import isEmpty from 'lodash/isEmpty';

const doInviteTenant = async payload => {
  return await SuperFetch.post(apiUrls.inviteTenant, payload)
    .then(res => res)
    .catch(error => ({ 
      error: JSON.stringify(error) 
    }));
};
export function* inviteTenant(payload) {
  const tenantInvite = yield call(doInviteTenant, payload.payload);
  if (tenantInvite && tenantInvite.result === "created") {
    yield put(actions.doInviteTenantSucceeded());
    yield put(actions.doListTenants('reference'));
    yield put(actions.doToggleNewReferenceForm(false));
  } else {
    yield put(
      actions.doInviteTenantFailed(tenantInvite)
    );
  }
}

const doAddTenant = async payload => {
  return await SuperFetch.post(apiUrls.addTenant, payload)
    .then(res => res)
    .catch(error => ({ 
      error: JSON.stringify(error) 
    }));
};
const doMakeTenantLink = async payload => {
  return await SuperFetch.post(apiUrls.addPropertyRentalTenant, payload)
    .then(res => res)
    .catch(error => ({ 
      error: JSON.stringify(error) 
    }));
};
export function* addTenant(payload) {
  let tenantSlotLink = null;
  const tenantInvite = yield call(doAddTenant, payload.payload);
  if (payload.payload.data.rentalDataHash !== null) {
    // figure out the payload here
    const postData = {
      data: {
        propertyHash: payload.payload.data.propertyHash,
        rentalDataHash: payload.payload.data.rentalDataHash,
        tenantId: tenantInvite.uid
      }
    };
    tenantSlotLink = yield call(doMakeTenantLink, postData);
  }

  if (tenantInvite && tenantInvite.result === "created") {
    yield put(actions.doAddCurrentTenantSucceeded(tenantInvite));
    yield put(actions.doListTenants('invite'));
    yield put(propertyActions.doGetRentalData(payload.payload.data.propertyHash));
    yield put(propertyActions.doGetPropertyRentalTenants(payload.payload.data.propertyHash));
    yield put(appActions.getUserData());
    yield put(actions.doToggleNewCurrentForm(false));
  } else {
    yield put(
      actions.doAddCurrentTenantFailed(tenantInvite)
    );
  }
}

const doListTenants = async payload => {
  const body = {
    data: {
      type: payload,
      show: 'hidden',
    }
  }
  return await SuperFetch.post(apiUrls.listTenants, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
};
export function* listTenants(payload) {
  const tenantList = yield call(doListTenants, payload.payload);
  if (tenantList && !isEmpty(tenantList)) {
    yield put({
      type: payload.payload === 'invite'
        ? actions.DO_LIST_CURRENT_TENANTS_SCCEEDED
        : actions.DO_LIST_REFERENCE_TENANTS_SCCEEDED,
      payload: tenantList
    });
  } else {
    yield put(
      payload.payload === 'invite'
        ? actions.doListCurrentTenantsFailed(tenantList)
        : actions.doListReferenceTenantsFailed(tenantList)
    );
  }
}

const doGetTenantRequestReference = async payload => {
  const queryString = payload ? `?hash=${payload}` : '';
  return await SuperFetch.post(apiUrls.landlordGetLandlordReference + queryString)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
};
export function* getTenantRequestReference(payload) {
  const referenceData = yield call(doGetTenantRequestReference, payload.payload);
  if (referenceData && !isEmpty(referenceData)) {
    yield put({
      type: actions.DO_GET_TENANT_REQUEST_REFERENCE_SUCCEEDED,
      payload: referenceData
    });
  } else {
    yield put({
      type: actions.DO_GET_TENANT_REQUEST_REFERENCE_FAILED,
      payload: referenceData
    });
  }
}

const doUpdateTenantRequestReference = async payload => {
  const queryString = payload ? `?hash=${payload.data.hash}` : '';
  return await SuperFetch.post(apiUrls.landlordUpdateLandlordReference + queryString, payload)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
};
export function* updateTenantRequestReference(payload) {
  const referenceData = yield call(doUpdateTenantRequestReference, payload.payload);
  if (referenceData && !isEmpty(referenceData)) {
    yield put({
      type: actions.DO_GET_TENANT_REQUEST_REFERENCE_SUCCEEDED,
      payload: referenceData
    });
  } else {
    yield put({
      type: actions.DO_GET_TENANT_REQUEST_REFERENCE_FAILED,
      payload: referenceData
    });
  }
}

const doGetOutstandingReferenceRequests = async () => {
  return await SuperFetch.post(apiUrls.landlordGetOutstandingReferences)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
};
export function* getOutstandingReferenceRequests(action) {
  const response = yield call(doGetOutstandingReferenceRequests);
  if (response && !isEmpty(response)) {
    yield put(actions.doGetOutstandingReferenceRequestsSuccess(response));
  } else {
    yield put(actions.doGetOutstandingReferenceRequestsFailed(response));
  }
}

const doGetRentVerifyDetails = async hash => {
  return await SuperFetch.post(apiUrls.getRentVerifyDetails + `?vhash=${hash}`)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
};
export function* getRentVerifyDetails(action) {
  const response = yield call(doGetRentVerifyDetails, action.payload);
  if (response && !isEmpty(response) && !response.error) {
    yield put(actions.doGetRentVerifyDetailsSuccess(response));
  } else {
    yield put(actions.doGetRentVerifyDetailsFailed(response));
  }
}

const doGetTenantReference = async hash => {
  const url = apiUrls.landlordGetTenantReference + `?t=${hash}`;
  return await SuperFetch.post(url, {})
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
export function* getTenantReference(action) {
  const response = yield call(doGetTenantReference, action.payload);
  if (response && !isEmpty(response)) {
    yield put(actions.doGetTenantReferenceSuccess(response));
  } else {
    yield put(actions.doGetTenantReferenceFailed(response));
  }
}

const doVerifyPayment = async (vhash, amount) => {
  return await SuperFetch.post(apiUrls.verifyPayment + `?vhash=${vhash}&a=${amount}`)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
};
export function* verifyPayment(action) {
  const { vhash, amount } = action.payload;
  const response = yield call(doVerifyPayment, vhash, amount);
  if (response && !isEmpty(response) && !response.error) {
    yield put(actions.doVerifyPaymentSuccess(response));
  } else {
    yield put(actions.doVerifyPaymentFailed(response));
  }
}

const doDeclinePayment = async (vhash, amount) => {
  return await SuperFetch.post(apiUrls.declinePayment + `?vhash=${vhash}&a=${amount}`)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
export function* declinePayment(action) {
  const { vhash, amount } = action.payload;
  const response = yield call(doDeclinePayment, vhash, amount);
  if (response && !isEmpty(response) && !response.error) {
    yield put(actions.doDeclinePaymentSuccess(response));
  } else {
    yield put(actions.doDeclinePaymentFailed(response));
  }
}

const doRemoveReferenceTenant = async (inviteHash) => {
  const body = {
    data: {
      inviteHash
    }
  };
  return await SuperFetch.post(apiUrls.removeTenantInvite, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
export function* removeReferenceTenant(action) {
  const hash = action.payload;
  const response = yield call(doRemoveReferenceTenant, hash);
  if (response && !response.error) {
    yield put(actions.doListTenants('reference'));
    yield put(actions.doRemoveTenantReferenceReset());
  } else {
    yield put(actions.doRemoveTenantReferenceFailed(response));
  }
}

const doRemoveInviteTenant = async (inviteHash) => {
  const body = {
    data: {
      inviteHash
    }
  };
  return await SuperFetch.post(apiUrls.removeTenantInvite, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
export function* removeInviteTenant(action) {
  const hash = action.payload;
  const response = yield call(doRemoveInviteTenant, hash);
  if (response && !response.error) {
    yield put(actions.doListTenants('invite'));
    yield put(actions.doRemoveTenantInviteReset());
  } else {
    yield put(actions.doRemoveTenantInviteFailed(response));
  }
}


export default function* rootSaga() {
  yield all([
    takeEvery(actions.DO_INVITE_TENANT, inviteTenant),
    takeEvery(actions.DO_ADD_CURRENT_TENANT, addTenant),
    takeEvery(actions.DO_LIST_CURRENT_TENANTS, listTenants),
    takeEvery(actions.DO_LIST_REFERENCE_TENANTS, listTenants),
    takeEvery(actions.DO_GET_TENANT_REQUEST_REFERENCE, getTenantRequestReference),
    takeEvery(actions.DO_UPDATE_TENANT_REQUEST_REFERENCE, updateTenantRequestReference),
    takeEvery(actions.DO_GET_OUTSTANDING_REFERENCE_REQUESTS, getOutstandingReferenceRequests),
    takeEvery(actions.DO_GET_TENANT_REFERENCE, getTenantReference),
    takeEvery(actions.DO_GET_RENT_VERIFY_DETAILS, getRentVerifyDetails),
    takeEvery(actions.DO_VERIFY_PAYMENT, verifyPayment),
    takeEvery(actions.DO_DECLINE_PAYMENT, declinePayment),
    takeEvery(actions.DO_REMOVE_REFERENCE_TENANT, removeReferenceTenant),
    takeEvery(actions.DO_REMOVE_INVITE_TENANT, removeInviteTenant),
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/tenants/sagas.js